function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9.09.36l50.77 29.32a2.68 2.68 0 010 4.65L9.09 63.64a2.68 2.68 0 01-4-2.32V2.69a2.68 2.68 0 014-2.33z",
  fill: "currentColor"
});

function SvgPlayFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgdmlld0JveD0iMCAwIDY0IDY0Ij48dGl0bGU+cGxheS1maWxsPC90aXRsZT48cGF0aCBkPSJNOS4wOS4zNiw1OS44NiwyOS42OGEyLjY4LDIuNjgsMCwwLDEsMCw0LjY1TDkuMDksNjMuNjRhMi42OCwyLjY4LDAsMCwxLTQtMi4zMlYyLjY5QTIuNjgsMi42OCwwLDAsMSw5LjA5LjM2WiIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9zdmc+";
export { SvgPlayFill as ReactComponent };